/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const d3 = require("../web/d3.v3");
window.d3 = d3;

//#
// HallPlan is used to draw a hall using an SVG Canvas and additional seat
// data.
//
// @author Philipp
window.HallPlan = class HallPlan {
  //#
  // Creates a new HallPlan instance
  //
  //     hall_plan = new HallPlan
  //       el: $("#svg")
  //       data: {"JSON data"}
  //
  constructor(options) {
    // Default settings
    let seat;
    var settings = {
      el: jQuery("svg"),
      data: jQuery("svg").parent().data("seats"),
      enableZoom: false,
      fitToParent: true,
      showTooltip: false,
      padding: 0,
      tooltip(d) {},
      selectMultiple: false,
      colors: {
        free: "#adadad",
        sold: "#ebebeb",
        selected: "#f39c12",
        hover: "#c0392b",
        restricted_view_border: "#000000",
        locked_border: "#AAAAAA",
      },
      onSelectionsUpdate(d) {},
      onReady() {},
      onClick(d, toggle) {
        if (toggle === undefined) {
          toggle = true;
        }

        if (!d.sold) {
          if ($.inArray(d.id, window.selected_seats) === -1) {
            d3.select(this).style("fill", color("selected", d));
            window.selected_seats.push(d.id);
          } else if (toggle) {
            d3.select(this).style("fill", color("hover", d));
            window.selected_seats.remove(d.id);
          }
          // notify
          return typeof settings.onSelectionsUpdate === "function"
            ? settings.onSelectionsUpdate(window.selected_seats)
            : undefined;
        }
      },
      onMouseOver(d) {
        if (d.sold && d.sold === true) {
          return;
        }
        if ($.inArray(d.id, window.selected_seats) === -1) {
          return d3.select(this).style("fill", color("hover", d));
        } else {
          return d3.select(this).style("fill", color("selected", d));
        }
      },
      onMouseOut(d) {
        if (d.sold && d.sold === true) {
          return;
        }
        if ($.inArray(d.id, window.selected_seats) === -1) {
          return d3.select(this).style("fill", color("free", d));
        } else {
          return d3.select(this).style("fill", color("selected", d));
        }
      },
    };

    // Merge default settings with options.
    settings = jQuery.extend(settings, options);
    settings.el = jQuery(settings.el);
    this.settings = settings;

    settings.el.data("hall_plan", this);

    if (settings.fitToParent) {
      this.settings.ratio = settings.el.height() / settings.el.width();

      this.fitToParent();
      $(window).on("resize", $.proxy(this.fitToParent, this));
    }

    const svg = d3.select(this.settings.el.selector);
    window.selected_seats = [];

    var color = function (type, data) {
      if (data && data.colors && data.colors[type]) {
        return data.colors[type];
      }
      return settings.colors[type];
    };
    d3.color = color;

    const groups = svg
      .select("#seats")
      .selectAll("g")
      .data(settings.data)
      .enter()
      .append("g")
      .selectAll("circle")
      .data((d) => d)
      .enter()
      .append("circle")
      .attr("id", (d) => "seat-" + d.id)
      .attr("cx", (d) => d.x)
      .attr("cy", (d) => d.y)
      .attr("r", function (d) {
        if (d.locked && d.locked === true) {
          return d.width / 3;
        } else {
          return d.width / 2;
        }
      })
      //.attr("height", ((d)-> d.height)))
      //.attr("shape-rendering", "crispEdges") # <- much awesome, so wow!
      .style("fill", function (d) {
        if (d.sold && d.sold === true) {
          return color("sold", d);
        } else if (d.selected != null && d.selected === true) {
          // Mark seats as selected.
          window.selected_seats.push(d.id);
          return color("selected", d);
        } else {
          return color("free", d);
        }
      })
      .attr("title", settings.tooltip)
      .style("cursor", function (d) {
        if (!d.sold || d.sold !== true) {
          return "pointer";
        }
      })
      .style("stroke", function (d) {
        if (d.restricted_view) {
          color("restricted_view_border", d);
        }
        if (d.locked) {
          return color("locked_border", d);
        }
      })
      .attr("data-toggle", "tooltip")
      .on("mouseover", settings.onMouseOver)
      .on("mouseout", settings.onMouseOut)
      .on("click", function (d) {
        return $.proxy(settings.onClick, this)(d, true);
      });
    if (settings.showTooltip) {
      $(`${this.settings.el.selector} #seats circle`).tooltip({
        placement: "top",
        container: "body",
      });
    }

    // make a seats array
    const seats = [];
    for (var group of Array.from(groups)) {
      for (seat of Array.from(group)) {
        seats.push(seat);
      }
    }

    if (settings.selectMultiple) {
      // emulating a mouse click based on this solution
      // http://stackoverflow.com/questions/12572644/differentiate-click-vs-mousedown-mouseup
      const holdStart = null;
      const holdDelay = 300;
      let holdActive = false;
      let holdStarter = null;

      svg.on("mousedown", function () {
        const p = d3.mouse(this);

        return (holdStarter = setTimeout(function () {
          holdStarter = null;
          holdActive = true;

          // begin normal hold operation here:
          const s = svg.select("rect.selection");
          if (s.empty()) {
            svg
              .append("rect")
              .attr({
                class: "selection",
                x: parseInt(p[0]),
                y: parseInt(p[1]),
                width: 10,
                height: 10,
                stroke: "gray",
                strokeWidth: 0.0000001, // ultra thin, so we dont get 2px border because of SVG scaling
                fill: "transparent",
              })
              .attr("shape-rendering", "crispEdges")
              .attr("data-x", parseInt(p[0]))
              .attr("data-y", parseInt(p[1]));
          }

          return settings.el.trigger("mousemove");
        }, holdDelay));
      });

      svg.on("mousemove", function () {
        let s = svg.select("rect.selection");

        if (!s.empty()) {
          const p = d3.mouse(this);
          const init = {
            x: parseInt(s.attr("data-x")),
            y: parseInt(s.attr("data-y")),
          };
          const d = {
            x: parseInt(s.attr("x")),
            y: parseInt(s.attr("y")),
            width: parseInt(s.attr("width")),
            height: parseInt(s.attr("height")),
          };
          const mouse = {
            x: p[0],
            y: p[1],
          };

          if (mouse.x <= init.x) {
            d.width = parseInt(init.x - mouse.x);
            d.x = parseInt(mouse.x);
          } else {
            d.width = parseInt(mouse.x - init.x);
            d.x = parseInt(init.x);
          }

          if (mouse.y <= init.y) {
            d.height = parseInt(init.y - mouse.y);
            d.y = parseInt(mouse.y);
          } else {
            d.height = parseInt(mouse.y - init.y);
            d.y = parseInt(init.y);
          }

          s.attr(d);

          // find out which seat is underneath
          const container = $(this);
          const containerOffset = container.offset();
          const selectionRect = container.find("rect.selection");
          if (selectionRect.length) {
            const selectionOffset = selectionRect.offset();
            const rect = {
              x: selectionOffset.left - containerOffset.left,
              y: selectionOffset.top - containerOffset.top,
              width: selectionRect[0].getBoundingClientRect().width,
              height: selectionRect[0].getBoundingClientRect().height,
            };
            return (() => {
              const result = [];
              for (s of Array.from(seats)) {
                var seat_data = __guard__(d3.select(s).data(), (x) => x[0]);
                const seatOffset = $(s).offset();
                const seatRadius = parseInt(d3.select(s).attr("r"), 10);
                seat = {
                  x: seatOffset.left - containerOffset.left + seatRadius,
                  y: seatOffset.top - containerOffset.top + seatRadius,
                };

                if (
                  seat.x > rect.x &&
                  seat.x <= rect.x + rect.width &&
                  seat.y > rect.y &&
                  seat.y <= rect.y + rect.height
                ) {
                  result.push($.proxy(settings.onMouseOver, s)(seat_data));
                } else {
                  result.push($.proxy(settings.onMouseOut, s)(seat_data));
                }
              }
              return result;
            })();
          }
        }
      });

      svg.on("mouseup", function () {
        let s = svg.select("rect.selection");
        if (holdStarter != null) {
          clearTimeout(holdStarter);
          // run click only option here
          // somehow this just works.
        } else if (holdActive) {
          holdActive = false;

          // end hold-only operation here
          if (!s.empty()) {
            const container = $(this);
            const containerOffset = container.offset();
            const selectionRect = container.find("rect.selection");
            if (selectionRect.length) {
              const selectionOffset = selectionRect.offset();
              const rect = {
                x: selectionOffset.left - containerOffset.left,
                y: selectionOffset.top - containerOffset.top,
                width: selectionRect[0].getBoundingClientRect().width,
                height: selectionRect[0].getBoundingClientRect().height,
              };
              // find out which seat is underneath
              for (s of Array.from(seats)) {
                var seat_data = __guard__(d3.select(s).data(), (x) => x[0]);
                const seatOffset = $(s).offset();
                const seatRadius = parseInt(d3.select(s).attr("r"), 10);
                seat = {
                  x: seatOffset.left - containerOffset.left + seatRadius,
                  y: seatOffset.top - containerOffset.top + seatRadius,
                };

                if (
                  seat.x > rect.x &&
                  seat.x <= rect.x + rect.width &&
                  seat.y > rect.y &&
                  seat.y <= rect.y + rect.height
                ) {
                  $.proxy(settings.onClick, s)(seat_data, false); // set second parameter to false to not toggle
                  $.proxy(settings.onMouseOut, s)(seat_data);
                }
              }
            }
          }
        }

        return svg.select(".selection").remove();
      });

      // attach event to unselect all button
      $(".svg-unselect-all").on("click", function () {
        for (var s of Array.from(seats)) {
          var d = __guard__(d3.select(s).data(), (x) => x[0]);
          if (!d.sold) {
            d3.select(s).style("fill", color("free", d));
            window.selected_seats.remove(d.id);
          }
        }
        return typeof settings.onSelectionsUpdate === "function"
          ? settings.onSelectionsUpdate(window.selected_seats)
          : undefined;
      });
    }

    if (settings.onSelectionsUpdate != null) {
      settings.onSelectionsUpdate(window.selected_seats);
    }
    if (settings.onReady != null) {
      settings.onReady();
    }
  }

  fitToParent() {
    // Resize the SVG to take 100% width
    const { ratio } = this.settings;
    const new_width = this.settings.el.parent().parent().innerWidth();
    const new_height = new_width * ratio;
    this.settings.el.attr("width", new_width + "px");
    this.settings.el.attr("height", new_height + "px");
    return this.settings.el.parent().css({
      width: new_width + "px",
      height: new_height + "px",
    });
  }

  findSeat(id) {
    let found = null;
    $(this.settings.el)
      .find("circle")
      .each(function () {
        const data = __guard__(d3.select(this).data(), (x) => x[0]);
        if (data != null && data.id != null && data.id === id) {
          return (found = data);
        }
      });
    return found;
  }
};

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined;
}
